import { IonButton, IonCol, IonRow, IonText } from "@ionic/react";

import {
  LogRegHeader,
  LogRegPageLayout,
} from "@/pages/login/components/LoginRegisterLayout";
import { SUPPORT_EMAIL } from "@/utils/constants/app";

import { MaintenanceScoopAnimation } from "./MaintenanceScoopAnimation";
import "./SiteMaintenancePage.css";
import "@/components/scoop-animation/scoop-animation-shared.css";

function SiteMaintenancePage() {
  return (
    <LogRegPageLayout>
      <MaintenanceScoopAnimation />
      <LogRegHeader
        title="Scheduled Maintenance"
        subHeader="My Fire Plane is temporarily unavailable. Please check back soon."
      />
      <IonRow className="content-sub-block ion-justify-content-center">
        <IonCol className="ion-text-center" size="auto">
          <IonText>For assistance, email </IonText>
          <IonButton
            className="scoop-support-email"
            fill="clear"
            href={`mailto:${SUPPORT_EMAIL}`}
          >
            {SUPPORT_EMAIL}
          </IonButton>
        </IonCol>
      </IonRow>
    </LogRegPageLayout>
  );
}

export { SiteMaintenancePage };
